import { useEffect, useState } from 'react';
import { hasAccess, ROLE_CARRIER, ROLE_OPERATOR } from '../../utils/access';

export const useValidations = (values, submitted) => {
  const [validations, updateValidations] = useState({});
  const checkValue = field => values[field] && (Array.isArray(values[field]) ? !!values[field].length : !!values[field].value);

  useEffect(() => {
    let newValidations = {
      all: true,
      operator: true,
      carrier: true,
      mailClass: true,
      reportingStartDate: true,
      reportingStopDate: true,
    };
    const tempValues = {};

    tempValues.reportingStartDate = !!values.reportingStartDate;
    tempValues.reportingStopDate = !!values.reportingStopDate;
    tempValues.mailClass = checkValue('mailClass');
    tempValues.operator = checkValue('operator');
    tempValues.carrier = checkValue('carrier');

    if (hasAccess([ROLE_CARRIER])) {
      tempValues.carrier = true;
    } else if (hasAccess([ROLE_OPERATOR])) {
      tempValues.operator = true;
    }

    newValidations.all = !Object.keys(tempValues).filter(item => !tempValues[item]).length;

    if (submitted) {
      newValidations = {
        ...newValidations,
        ...tempValues,
      };
    }

    updateValidations(newValidations);
  }, [values, submitted]);

  return [validations];
};
